import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { SectionHeader } from '@factorialco/f0-react/dist/experimental'
import { CreditCard } from '@factorialco/f0-react/icons/app'
import { BenefitsMyBenefitsHomePageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect, useUnsafeEffect } from 'modules/core/hooks/useEffect'
import { useLazyQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { CardSidepanel } from 'modules/banking/components/CardSidepanel'
import { BenefitBalancesList } from 'modules/benefits/pages/MyBenefits/BenefitBalancesList'
import SpendingDataCollection from 'modules/benefits/pages/MyBenefits/SpendingDataCollection'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const MyBenefitsHomePage = () => {
  const { employee } = useCurrentSession()
  const [myBenefitsCardBalancesQuery, { data, loading, error }] = useLazyQuery(
    BenefitsMyBenefitsHomePageDocument,
    {
      fetchPolicy: 'no-cache',
      variables: {
        employeeIds: [employee.id],
      },
    }
  )

  useUnsafeEffect(() => {
    if (!employee) {
      throw new Error('Employee not found')
    }

    myBenefitsCardBalancesQuery()
  }, [employee, myBenefitsCardBalancesQuery])

  const benefitCardId =
    data?.apiCore.currentsConnection.nodes[0]?.employee?.bankingCardholder?.cards[0]?.id

  const [showCardSidePanel, setShowCardSidePanel] = useState(false)

  useEffect(() => {
    track(trackingEvents.benefits.openMyBenefitsHomePage)
  }, [])

  const action = benefitCardId
    ? {
        icon: CreditCard,
        label: i18n.t('benefits.my_benefits.spending.card_details_button'),
        onClick: () => setShowCardSidePanel(true),
        variant: 'default' as const,
      }
    : undefined

  return (
    <ResponsivePage.Body loading={loading} error={error} variant="full">
      <SectionHeader
        title={i18n.t('benefits.my_benefits.spending.title')}
        description={i18n.t('benefits.my_benefits.spending.description')}
        action={action}
      />

      {data && (
        <>
          <Box paddingTop="s24" />
          <BenefitBalancesList
            benefitBalancesList={{
              benefitBalancesConnection: data.benefits.benefitBalancesConnection,
            }}
          />
          <Box paddingTop="s24" />
          <SpendingDataCollection
            benefitCategoriesList={
              data.benefits.benefitEmployeesConnection?.edges?.[0]?.node?.activeBenefits || []
            }
          />
          {showCardSidePanel && benefitCardId && (
            <CardSidepanel cardId={benefitCardId} onClose={() => setShowCardSidePanel(false)} />
          )}
        </>
      )}
    </ResponsivePage.Body>
  )
}

export default MyBenefitsHomePage
